<template>
    <div 
        class="guide-grid-channel" 
        :class="{'guide-grid-channel_isFocused': isFocused}"
    >
        <div class="guide-grid-channel-number">{{ channel.accessNum }}</div>
        <div class="guide-grid-channel-logo">
            <img class="guide-grid-channel-logo-image" :src="image" :alt="channel.name || ''" loading="lazy">
            <common-icon v-if="isIconStar" class="guide-grid-channel-logo-favorite" :icon-name="'IconStar'" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType, type Ref, ref, computed, onBeforeMount, onMounted, nextTick } from "vue";
    import type { Channel } from "@ca.vmedia.tv/domains";
    import { useFavoriteChannelsStore } from "@/stores/FavoriteChannels";
    import { storeToRefs } from 'pinia';
    import { useGuideStore } from "@/stores/Guide";

    const GuideStoreModule = useGuideStore();
    const {
        configProgram,
    } = storeToRefs(GuideStoreModule)

    const FavoriteChannelsStoreModule = useFavoriteChannelsStore();
    const {
        getFavChannelsIds: favChannels,
    } = storeToRefs(FavoriteChannelsStoreModule);

    const props = defineProps({
        channel: {
            type: Object as PropType<Channel>,
            required: true,
        },
        channelIdx: {
            type: Number,
            required: true,
        },
    });
    const emit = defineEmits(['loaded-row'])
    const { $domains } = useNuxtApp();
    const {guideConfig} = useAppConfig();
    const featureChannelLogoOriginalEnabled = guideConfig.featureChannelLogoOriginalEnabled;
    const image: Ref<string> = ref('');


    const focusedChannelIdx = computed((): number => {
        const [channelIdx] = configProgram.value;
        return channelIdx ;
    });
    const isFocused = computed((): boolean => focusedChannelIdx.value === props.channelIdx);
    const isIconStar = computed((): boolean => props.channel.id ? favChannels.value.includes(props.channel.id) : false);
    

    const loadData = async (): Promise<void> => {
        try {
            image.value = featureChannelLogoOriginalEnabled 
                ? await $domains.imagesRepository.getChannelImageOriginal(props.channel.images) ?? ''
                : await $domains.imagesRepository.getWhiteChannelImage(props.channel.images) ?? '';
        } catch (error) {
            Logger.captureError(error as Error);
            image.value = '';
        }
    };

    onBeforeMount(() => {
        void loadData();
    });
 
    onMounted(() => {
        void nextTick(() => {
            emit('loaded-row');
        });
    });
</script>
